module.exports = __webpack_public_path__ + "img/bannerIngles.2849f875.jpeg";